import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { IColorTheme } from '../../types/itemTypes'

export const QuantityStyles = styled.div`
  height: 26px;
  display: flex;
`
export const IncrementButton = styled.button`
  /* extra specificity to override inherited */
  && {
    border: none;
    color: ${({ theme: { colorTheme } }): string => colorTheme.colourTextOnHighlight};
    background-color: ${({ theme: { colorTheme } }): string => colorTheme.colourHighlight};
    font-size: 16px;
    width: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme: { colorTheme, limit } }): string => (limit
    ? `background-color: ${colorTheme.fade}`
    : `:hover { background-color: ${colorTheme.hover} }`)};
  }
`
export const QuantityCounter = styled.div`
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 26px;
  border-width: 1px 0;
  border-style: solid;
  border-color: ${({ theme: { colorTheme } }): string => colorTheme.fade};
`

export interface IQuantityProps {
  maxPerOrder?: number | null
  selectedQuantity: number
  selectQuantity: (quantity: number) => void
  colorTheme: IColorTheme
  quantitySold?: number
  quantity?: number | null
}

export default function Quantity(props: IQuantityProps): ReactElement {
  const {
    maxPerOrder,
    selectedQuantity,
    selectQuantity,
    colorTheme,
    quantitySold,
    quantity,
  } = props

  const atDecrementLimit = selectedQuantity <= 1
  const decrement = (): void => {
    if (!atDecrementLimit) selectQuantity(selectedQuantity - 1)
  }

  const remaining = (quantity
    && (quantitySold || quantitySold === 0)
    && quantity - quantitySold)
    || null

  const overRemaining = (remaining || remaining === 0) && selectedQuantity >= remaining
  const overMax = maxPerOrder && selectedQuantity >= maxPerOrder
  const over100 = !maxPerOrder && selectedQuantity >= 100
  const atIncrementLimit = overMax || overRemaining || over100
  const increment = (): void => {
    if (!atIncrementLimit) selectQuantity(selectedQuantity + 1)
  }

  return (
    <QuantityStyles>
      <IncrementButton
        onClick={decrement}
        theme={{ colorTheme, limit: atDecrementLimit }}
      >
        &#8722;
      </IncrementButton>
      <QuantityCounter theme={{ colorTheme }}>
        {selectedQuantity}
      </QuantityCounter>
      <IncrementButton
        onClick={increment}
        theme={{ colorTheme, limit: atIncrementLimit }}
      >
        &#43;
      </IncrementButton>
    </QuantityStyles>
  )
}
